import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { localImages, stringsList, overviewFilters, overviewStatistics } from '../../../dashboard/constants/app-config'

@Component({
  selector: 'app-client-update-dialog',
  templateUrl: './client-update-dialog.component.html',
  styleUrls: ['./client-update-dialog.component.css']
})
export class ClientUpdateDialogComponent implements OnInit {
  localImages = localImages
  visibility = [
    {
      id: 'old',
      visible: false
    },
    {
      id: 'new',
      visible: false
    },
    {
      id: 'repeat',
      visible: false
    }
  ]

  updateClient = {
    username: '',
    company: '',
    email: '',
    address: '',
    city: '',
    phone: '',
    oldPassword: '**************',
    newPassword: '**************',
    retypePassword: '**************',
  }

  constructor(public dialogRef: MatDialogRef<ClientUpdateDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    if (this.data) this.updateClient = this.data
  }

  saveChanges() {
    this.dialogRef.close({action: 'Save changes', data: this.updateClient})
  }

  toggleVisibility(id: string) {
    const oldVisibility = this.visibility.find(item => item.id === id)
    this.visibility = this.visibility.filter(item => item.id !== id)
    this.visibility = [...this.visibility, { id, visible: ! oldVisibility?.visible}]
  }

  visibilityPerInput(id: string) {
    return (this.visibility.find(item => item.id === id))?.visible
  }

}
